<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <div class="no-print" align="center">
          <a v-if="lang == 'th'" @click="switchLanguage('en')"
            >Change Language to English (CLICK)</a
          >
          <a v-if="lang == 'en'" @click="switchLanguage('th')"
            >เปลี่ยนเป็นภาษาไทย (CLICK)</a
          >
          <br />
          <v-btn @click="print" color="primary" dark>
            <span v-if="lang == 'en'">
              Print as a file to attach the assessment form.</span
            >
            <span v-if="lang == 'th'">Print เป็นไฟล์เพื่อแนบแบบประเมิน</span>
            <v-icon right dark> mdi-printer </v-icon>
          </v-btn>
        </div>

        <h1 v-if="lang == 'th'" class="display font-weight-bold mb-3">
          ข้อมูลงานบริการทางวิชาการ (ปีการศึกษา {{ year + 543 }})
        </h1>
        <h1 v-if="lang == 'en'" class="display font-weight-bold mb-3">
          Academic Service Data (Academic Year {{ year }})
        </h1>

        <h2>{{ userData.emp_name_tha }} ({{ userData.emp_id }})</h2>
        <h2 v-if="total <= 40">
          <span v-if="lang == 'th'"> รวม {{ total.toFixed(2) }} คะแนน</span>
          <span v-if="lang == 'en'"> Sum {{ total.toFixed(2) }} Points</span>
        </h2>
        <h2 v-else>
          <span v-if="lang == 'th'"> รวม {{ total.toFixed(2) }} คะแนน</span>
          <span v-if="lang == 'en'"> Sum {{ total.toFixed(2) }} Points</span>
        </h2>
        <v-btn @click="getTransactionAll(2022)" color="primary" dark>
          <span v-if="lang == 'th'"> แสดงเฉพาะปีการศึกษา 2565</span>
          <span v-if="lang == 'en'"> Show only academic year 2565</span>
        </v-btn>
        <span> | </span>
        <v-btn @click="getTransactionAll(2023)" color="primary" dark>
          <span v-if="lang == 'th'"> แสดงเฉพาะปีการศึกษา 2566</span>
          <span v-if="lang == 'en'"> Show only academic year 2566</span>
        </v-btn>
        <span> | </span>
        <v-btn @click="getTransactionAll(2024)" color="primary" dark>
          <span v-if="lang == 'th'"> แสดงเฉพาะปีการศึกษา 2567</span>
          <span v-if="lang == 'en'"> Show only academic year 2567</span>
        </v-btn>
        <span> | </span>
        <v-btn @click="getTransactionAll(2000)" color="primary" dark>
          <span v-if="lang == 'th'"> แสดงทั้งหมด</span>
          <span v-if="lang == 'en'"> Show All</span>
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <br />
      <h2 v-if="lang == 'th'">
        3.1 โครงการบริการวิชาการแบบมีรายได้
        (ศูนย์บริการทางวิชาการเป็นผู้กรอกข้อมูลและยืนยันคะแนน)
      </h2>
      <h2 v-if="lang == 'en'">
        3.1 Income-generating Academic Service Project (The Academic Service
        Center is responsible for data entry and score confirmation).
      </h2>
    </div>
    <v-row>
      <v-col cols="12">
        <template>
          <v-card>
            <v-card-title>
              <span v-if="lang == 'th'">
                คะแนนรวม {{ sum1 }} คะแนน (จำนวนเงินจัดสรรให้มหาวิทยาลัย
                {{ formatNumber(totalmoney) }} บาท)</span
              >

              <span v-if="lang == 'en'">
                Total {{ sum1 }} points (Amount allocated to the university
                {{ formatNumber(totalmoney) }} Baht)</span
              >
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search1"
                append-icon="mdi-magnify"
                label="ค้นหา/search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers1Selected"
              :items="transactionData1"
              :loading="loading1"
              :search="search1"
              :sort-by="['timestamp']"
              :sort-desc="[true]"
            >
              <template slot="progress">
                <v-progress-linear
                  color="blue"
                  indeterminate
                ></v-progress-linear>
              </template>

              <template v-slot:[`item.startdate`]="{ item }">
                {{ formatTimestamp(item.startdate) }}
              </template>
              <template v-slot:[`item.type`]="{ item }">
                {{ item.type }} ({{ item.charge }}%)
              </template>
              <template v-slot:[`item.value`]="{ item }">
                {{ formatNumber(item.value) }}
              </template>
              <template v-slot:[`item.paiddate`]="{ item }">
                {{ formatTimestamp(item.paiddate) }}
              </template>
              <template v-slot:[`item.servicecharge`]="{ item }">
                {{ formatNumber(item.servicecharge) }}
              </template>

              <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-icon large color="yellow darken-2" @click="editItem(item)"
                  >mdi-pencil-outline
                </v-icon>

                <v-icon large color="red darken-2" @click="deleteItem(item)"
                  >mdi-close-circle
                </v-icon>
              </template> -->
            </v-data-table>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <hr />
    <div>
      <br />
      <h2 v-if="lang == 'th'">
        3.2 โครงการบริการวิชาการเพื่อสนับสนุนงานประกันคุณภาพ
        (ศูนย์บริการทางวิชาการเป็นผู้กรอกข้อมูลและร่วมพิจารณาคะแนนร่วมกับคณะ/วิทยาลัย)
      </h2>
      <h2 v-if="lang == 'en'">
        3.2 Academic Service Project for Quality Assurance Support, responsible
        party or project team members in the Academic Service Project solely for
        the purpose of supporting quality assurance efforts
      </h2>
    </div>
    <v-row>
      <v-col cols="12">
        <template>
          <v-card>
            <v-card-title>
              <span v-if="lang == 'th'"> คะแนนรวม {{ sum2 }} คะแนน</span>
              <span v-if="lang == 'en'"> Total {{ sum2 }} points</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search2"
                append-icon="mdi-magnify"
                label="ค้นหา/search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers2Selected"
              :items="transactionData2"
              :loading="loading2"
              :search="search2"
              :sort-by="['timestamp']"
              :sort-desc="[true]"
            >
              <template slot="progress">
                <v-progress-linear
                  color="blue"
                  indeterminate
                ></v-progress-linear>
              </template>

              <template v-slot:[`item.timestamp`]="{ item }">
                {{ formatTimestamp(item.timestamp) }}
              </template>
              <template v-slot:[`item.startdate`]="{ item }">
                {{ formatTimestamp(item.startdate) }}
              </template>
              <template v-slot:[`item.enddate`]="{ item }">
                {{ formatTimestamp(item.enddate) }}
              </template>
              <template v-slot:[`item.cost`]="{ item }">
                {{ formatNumber(item.cost) }}
              </template>

              <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-icon large color="yellow darken-2" @click="editItem(item)"
                  >mdi-pencil-outline
                </v-icon>

                <v-icon large color="red darken-2" @click="deleteItem(item)"
                  >mdi-close-circle
                </v-icon>
              </template> -->
            </v-data-table>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <!-- <v-btn
      @click="dialog2 = true"
      color="primary"
      dark
      v-bind="attrs"
      v-on="on"
    >
      Open Dialog
    </v-btn> -->
    <hr />
    <div>
      <br />
      <h2 v-if="lang == 'th'">
        3.3 ได้รับเชิญเป็นวิทยากร อาจารย์พิเศษ กรรมการ อนุกรรมการ ผู้ทรงคุณวุฒิ
        (บุคลากรเป็นผู้กรอกข้อมูลโดยคณะ/วิทยาลัย เป็นผู้ตรวจสอบและยืนยันคะแนน)
      </h2>
      <h2 v-if="lang == 'en'">
        3.3 Invited as a Guest Speaker, Lecturer, Special lecturer, Member,
        Committee, Sub-committee, Expert (Staff fill in the information.
        Faculty/College Be the one who checks and confirms the score.)
      </h2>
      <span v-if="lang == 'th'"
        >(สำหรับใช้เป็นทางเลือกในการกรอกข้อมูลด้านบริการทางวิชาการสำหรับการประเมินประจำปี)</span
      >
      <span v-if="lang == 'en'"
        >(For use as an alternative to filling out academic service information
        for the annual assessment.)</span
      >
    </div>
    <v-row>
      <v-col cols="12">
        <template>
          <v-card>
            <v-card-title>
              <span v-if="lang == 'th'"> คะแนนรวม {{ sum3 }} คะแนน</span>
              <span v-if="lang == 'en'"> Total {{ sum3 }} points</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search3"
                append-icon="mdi-magnify"
                label="ค้นหา/search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers3Selected"
              :items="transactionData3"
              :loading="loading3"
              :search="search3"
              :sort-by="['timestamp']"
              :sort-desc="[true]"
            >
              <template slot="progress">
                <v-progress-linear
                  color="blue"
                  indeterminate
                ></v-progress-linear>
              </template>

              <template v-slot:[`item.timestamp`]="{ item }">
                {{ formatTimestamp(item.timestamp) }}
              </template>
              <template v-slot:[`item.startdate`]="{ item }">
                {{ formatTimestamp(item.startdate) }}
              </template>
              <template v-slot:[`item.recipienttype`]="{ item }">
                <span v-if="lang == 'th'">
                  {{ item.recipienttype }}
                </span>
                <span v-if="lang == 'en'">
                  <span v-if="item.recipienttype == 'ภายใน'"> Insite </span>
                  <span v-if="item.recipienttype == 'ภายนอก'"> External </span>
                </span>
              </template>
              <template v-slot:[`item.result`]="{ item }">
                <span v-if="lang == 'th'">
                  {{ item.result }}
                </span>
                <span v-if="lang == 'en'">
                  <span v-if="item.result == 'ระยะเวลาไม่เกิน 6 ชั่วโมง'">
                    Working time not more than 6 hours
                  </span>
                  <span v-if="item.result == 'ระยะเวลาไม่เกิน 12 ชั่วโมง'">
                    Working time not more than 12 hours
                  </span>
                  <span v-if="item.result == 'ระยะเวลามากกว่า 12 ชั่วโมง'">
                    Working time more than 12 hours
                  </span>
                </span>
              </template>
              <template v-slot:[`item.enddate`]="{ item }">
                {{ formatTimestamp(item.enddate) }}
              </template>
              <template v-slot:[`item.url`]="{ item }">
                <v-btn v-if="item.url" icon :href="item.url" target="_blank">
                  <v-icon>mdi-file-cloud-outline</v-icon>
                </v-btn>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="yellow darken-2" icon @click="editItem3(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn color="red darken-2" icon @click="deleteItem3(item)">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <div align="center">
      <br />
      <v-btn
        @click="
          dialog3 = true;
          clear();
        "
        color="primary"
        dark
        class="no-print"
      >
        <span v-if="lang == 'th'">เพิ่มข้อมูล</span>
        <span v-if="lang == 'en'">Add Data</span>
      </v-btn>
    </div>
    <br />
    <v-row>
      <v-col cols="3"> </v-col>
      <v-col cols="6">
        <template class="sarabun">
          <v-row justify="center">
            <v-dialog v-model="dialog3" persistent max-width="500px">
              <v-card>
                <v-toolbar color="primary" dark
                  >{{ formTitle }}
                  <span v-if="lang == 'th'">ข้อมูลบริการทางวิชาการข้อ 3.3</span>
                  <span v-if="lang == 'en'">
                    &nbsp;Academic service information 3.3</span
                  >
                </v-toolbar>

                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'ชื่อ โครงการ/กิจกรรม/สมาคม/สภาวิชาชีพ/คณะกรรมการ'
                              : 'Name of project/activity/association/professional council/committee'
                          "
                          required
                          v-model="editedItem.name"
                          :rules="nameRule"
                        ></v-text-field>
                        <v-select
                          :items="positionListSelected"
                          :label="lang == 'th' ? 'หน้าที่/บทบาท' : 'Position'"
                          v-model="editedItem.position"
                          :rules="positionRule"
                        ></v-select>
                        <v-text-field
                          v-if="editedItem.position == 'อื่น ๆ โปรดระบุ'"
                          :label="
                            lang == 'th'
                              ? 'กรุณาระบุหน้าที่ในโครงการ'
                              : 'Please specify the position in the project'
                          "
                          required
                          v-model="position"
                          :rules="positionRule"
                        ></v-text-field>
                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'ชื่อหน่วยงานที่รับบริการ'
                              : 'Name of recipient'
                          "
                          required
                          v-model="editedItem.recipient"
                          :rules="recipientRule"
                        ></v-text-field>
                        <p style="font-size: 1.1em">
                          <span v-if="lang == 'th'">
                            ประเภทหน่วยงานที่รับบริการ</span
                          >
                          <span v-if="lang == 'en'"> Type of recipient</span>
                        </p>
                        <v-radio-group
                          v-model="editedItem.recipienttype"
                          row
                          :rules="recipienttypeRule"
                          required
                        >
                          <v-radio
                            :label="lang == 'th' ? 'ภายใน' : 'Insite'"
                            value="ภายใน"
                          ></v-radio>
                          <v-radio
                            :label="lang == 'th' ? 'ภายนอก' : 'External'"
                            value="ภายนอก"
                          ></v-radio>
                        </v-radio-group>

                        <p style="font-size: 1.1em">
                          {{
                            lang == "th" ? "ระยะเวลาในการทำงาน" : "Working time"
                          }}
                        </p>
                        <v-radio-group
                          v-model="editedItem.result"
                          :rules="resultRule"
                          required
                        >
                          <v-radio
                            :label="
                              lang == 'th'
                                ? 'ระยะเวลาไม่เกิน 6 ชั่วโมง'
                                : 'Working time not more than 6 hours'
                            "
                            value="ระยะเวลาไม่เกิน 6 ชั่วโมง"
                          ></v-radio>
                          <v-radio
                            :label="
                              lang == 'th'
                                ? 'ระยะเวลาไม่เกิน 12 ชั่วโมง'
                                : 'Working time not more than 12 hours'
                            "
                            value="ระยะเวลาไม่เกิน 12 ชั่วโมง"
                          ></v-radio>
                          <v-radio
                            :label="
                              lang == 'th'
                                ? 'ระยะเวลามากกว่า 12 ชั่วโมง'
                                : 'Working time more than 12 hours'
                            "
                            value="ระยะเวลามากกว่า 12 ชั่วโมง"
                          ></v-radio>
                        </v-radio-group>

                        <v-dialog
                          ref="dialog31"
                          v-model="modal31"
                          :return-value.sync="editedItem.startdate"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.startdate"
                              :label="
                                lang == 'th'
                                  ? 'วันที่เริ่มโครงการ'
                                  : 'Start date'
                              "
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            @change="editedItem.enddate = editedItem.startdate"
                            v-model="editedItem.startdate"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn color="red" dark @click="modal31 = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              color="green"
                              dark
                              @click="$refs.dialog31.save(editedItem.startdate)"
                            >
                              Select Date
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                        <v-dialog
                          ref="dialog32"
                          v-model="modal32"
                          :return-value.sync="editedItem.enddate"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.enddate"
                              :rules="[checkEndDate]"
                              :label="
                                lang == 'th' ? 'วันที่จบโครงการ' : 'End date'
                              "
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.enddate"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modal32 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog32.save(editedItem.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'Link เอกสารหรือภาพประกอบ'
                              : 'Link of Document or Picture'
                          "
                          required
                          v-model="editedItem.url"
                          :rules="urlRule"
                        ></v-text-field>

                        <span v-if="!showFormUpload">
                          {{
                            lang == "th"
                              ? "หากต้องการอัปโหลดไฟล์ กดที่ปุ่มนี้"
                              : "To upload a file, press this button."
                          }}
                          <v-btn icon @click="showFormUpload = true">
                            <v-icon>mdi-cloud-upload-outline</v-icon>
                          </v-btn></span
                        >
                        <v-file-input
                          v-if="showFormUpload"
                          accept="image/*,.pdf"
                          label="เลือกเอกสารหรือภาพประกอบที่จะอัปโหลด"
                          v-model="fileUpload"
                        ></v-file-input>
                        <v-btn
                          v-if="showFormUpload && fileUpload != null"
                          color="primary "
                          dark
                          :loading="uploadprogress > 0 && uploadprogress < 100"
                          @click="uploadFile"
                        >
                          Upload File
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red " dark @click="dialog3 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="green "
                    :disabled="!valid"
                    style="color: white"
                    @click="validate(3)"
                  >
                    {{ formTitle }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-col>
      <v-col cols="3"> </v-col>
    </v-row>

    <hr />
    <div>
      <br />
      <h2 v-if="lang == 'th'">
        3.4 ได้รับเชิญเป็นผู้ทรงคุณวุฒิพิจารณาผลงานวิชาการ
        (บุคลากรเป็นผู้กรอกข้อมูลโดยคณะ/วิทยาลัย เป็นผู้ตรวจสอบและยืนยันคะแนน)
      </h2>
      <h2 v-if="lang == 'en'">
        3.4 Appointed as a Qualified Reviewer to Evaluate Academic Works and
        Research Articles. (Staff fill in the information. Faculty/College Be
        the one who checks and confirms the score.)
      </h2>
      <span v-if="lang == 'th'"
        >(สำหรับใช้เป็นทางเลือกในการกรอกข้อมูลด้านบริการทางวิชาการสำหรับการประเมินประจำปี)</span
      >
      <span v-if="lang == 'en'"
        >(For use as an alternative to filling out academic service information
        for the annual assessment.)</span
      >
    </div>
    <v-row>
      <v-col cols="12">
        <template>
          <v-card>
            <v-card-title>
              <span v-if="lang == 'th'"> คะแนนรวม {{ sum4 }} คะแนน</span>
              <span v-if="lang == 'en'"> Total {{ sum4 }} points</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search4"
                append-icon="mdi-magnify"
                label="ค้นหา/search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers4Selected"
                :items="transactionData4"
                :loading="loading4"
                :search="search4"
                :sort-by="['timestamp']"
                :sort-desc="[true]"
              >
                <template slot="progress">
                  <v-progress-linear
                    color="blue"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:item.startdate="{ item }">
                  {{ formatTimestamp(item.startdate) }}
                </template>
                <template v-slot:item.enddate="{ item }">
                  {{ formatTimestamp(item.enddate) }}
                </template>
                <template v-slot:item.recipienttype="{ item }">
                  <span v-if="lang == 'th'">
                    {{ item.recipienttype }}
                  </span>
                  <span v-if="lang == 'en'">
                    <span v-if="item.recipienttype == 'ภายใน'"> Insite </span>
                    <span v-if="item.recipienttype == 'ภายนอก'">
                      External
                    </span>
                  </span>
                </template>
                <template v-slot:item.timestamp="{ item }">
                  {{ formatTimestamp(item.timestamp) }}
                </template>

                <template v-slot:item.url="{ item }">
                  <v-btn v-if="item.url" icon :href="item.url" target="_blank">
                    <v-icon>mdi-file-cloud-outline</v-icon>
                  </v-btn>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn color="yellow darken-2" icon @click="editItem4(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn color="red darken-2" icon @click="deleteItem4(item)">
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <div align="center">
      <br />
      <v-btn
        @click="
          dialog4 = true;
          clear();
        "
        color="primary"
        dark
        class="no-print"
      >
        <span v-if="lang == 'th'">เพิ่มข้อมูล</span>
        <span v-if="lang == 'en'">Add Data</span>
      </v-btn>
    </div>

    <v-row>
      <v-col cols="3"> </v-col>
      <v-col cols="6">
        <template class="sarabun">
          <v-row justify="center">
            <v-dialog v-model="dialog4" persistent max-width="500px">
              <v-card>
                <v-toolbar color="primary" dark
                  >{{ formTitle }}
                  <span v-if="lang == 'th'">ข้อมูลบริการทางวิชาการข้อ 3.4</span>
                  <span v-if="lang == 'en'">
                    &nbsp;Academic service information 3.4</span
                  ></v-toolbar
                >

                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'วารสาร/งานประชุมวิชาการ/การพิจารณาตำแหน่งวิชาการ'
                              : 'Name of Journal/Conference/Academic Position'
                          "
                          required
                          v-model="editedItem.name"
                          :rules="typenameRule"
                        ></v-text-field>
                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'ชื่อ บทความ/ผลงาน/โครงการ '
                              : 'Name of Article/Work/Project'
                          "
                          required
                          v-model="editedItem.projectname"
                          :rules="projectnameRule"
                        ></v-text-field>

                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'ชื่อหน่วยงานที่รับบริการ'
                              : 'Name of Recipient'
                          "
                          required
                          v-model="editedItem.recipient"
                          :rules="recipientRule"
                        ></v-text-field>
                        <p style="font-size: 1.1em">
                          <span v-if="lang == 'th'"
                            >ประเภทหน่วยงานที่รับบริการ</span
                          >
                          <span v-if="lang == 'en'">Type of Recipient</span>
                        </p>
                        <v-radio-group
                          v-model="editedItem.recipienttype"
                          row
                          :rules="recipienttypeRule"
                          required
                        >
                          <v-radio
                            :label="lang == 'th' ? 'ภายใน' : 'Insite'"
                            value="ภายใน"
                          ></v-radio>
                          <v-radio
                            :label="lang == 'th' ? 'ภายนอก' : 'External'"
                            value="ภายนอก"
                          ></v-radio>
                        </v-radio-group>
                        <!-- <v-container class="px-0" fluid>
                            <p style="font-size: 1.1em">ระยะเวลาในการทำงาน</p>
                            <v-radio-group
                              v-model="editedItem.result"
                              :rules="resultRule"
                              required
                            >
                              <v-radio
                                label="ระยะเวลาไม่เกิน 6 ชั่วโมง"
                                value="ระยะเวลาไม่เกิน 6 ชั่วโมง"
                              ></v-radio>
                              <v-radio
                                label="ระยะเวลาไม่เกิน 12 ชั่วโมง"
                                value="ระยะเวลาไม่เกิน 12 ชั่วโมง"
                              ></v-radio>
                              <v-radio
                                label="ระยะเวลามากกว่า 12 ชั่วโมง"
                                value="ระยะเวลามากกว่า 12 ชั่วโมง"
                              ></v-radio>
                            </v-radio-group>
                          </v-container> -->
                        <v-dialog
                          ref="dialog41"
                          v-model="modal41"
                          :return-value.sync="editedItem.startdate"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.startdate"
                              :label="
                                lang == 'th'
                                  ? 'วันที่เริ่มโครงการ'
                                  : 'Start Date'
                              "
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            @change="editedItem.enddate = editedItem.startdate"
                            v-model="editedItem.startdate"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn color="red" dark @click="modal41 = false">
                              {{ lang == "th" ? "ยกเลิก" : "Cancel" }}
                            </v-btn>
                            <v-btn
                              color="green"
                              dark
                              @click="$refs.dialog41.save(editedItem.startdate)"
                            >
                              {{ lang == "th" ? "เลือกวัน" : "Select Date" }}
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                        <v-dialog
                          ref="dialog42"
                          v-model="modal42"
                          :return-value.sync="editedItem.enddate"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.enddate"
                              :rules="[checkEndDate]"
                              :label="
                                lang == 'th' ? 'วันที่จบโครงการ' : 'End Date'
                              "
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.enddate"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modal42 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog42.save(editedItem.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                        <v-text-field
                          :label="
                            lang == 'th'
                              ? 'Link เอกสารหรือภาพประกอบ'
                              : 'Link of Document or Picture'
                          "
                          required
                          v-model="editedItem.url"
                          :rules="urlRule"
                        ></v-text-field>

                        <span v-if="!showFormUpload">
                          {{
                            lang == "th"
                              ? "หากต้องการอัปโหลดไฟล์ กดที่ปุ่มนี้"
                              : "To upload a file, press this button."
                          }}
                          <v-btn icon @click="showFormUpload = true">
                            <v-icon>mdi-cloud-upload-outline</v-icon>
                          </v-btn></span
                        >
                        <v-file-input
                          v-if="showFormUpload"
                          accept="image/*,.pdf"
                          :label="
                            lang == 'th'
                              ? 'เลือกเอกสารหรือภาพประกอบที่จะอัปโหลด'
                              : 'Select a document or picture to upload'
                          "
                          v-model="fileUpload"
                        ></v-file-input>
                        <v-btn
                          v-if="showFormUpload && fileUpload != null"
                          color="primary "
                          dark
                          :loading="uploadprogress > 0 && uploadprogress < 100"
                          @click="uploadFile"
                        >
                          {{ lang == "th" ? "อัปโหลด" : "Upload" }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red " dark @click="dialog4 = false">
                    {{ lang == "th" ? "ยกเลิก" : "Cancel" }}
                  </v-btn>
                  <v-btn
                    color="green "
                    :disabled="!valid"
                    style="color: white"
                    @click="validate(4)"
                  >
                    {{ formTitle }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-col>
      <v-col cols="3"> </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-dialog v-model="dialogDelete3" max-width="500px">
          <v-card class="card-shadow card-padding">
            <v-card-title>
              {{
                lang == "th"
                  ? "คุณแน่ใจว่าต้องการลบ"
                  : "Are you sure you want to delete"
              }}
              ({{ itemSelected.name }})</v-card-title
            >
            <v-card-actions class="pb-0">
              <v-spacer></v-spacer>
              <v-btn dark @click="closeDelete" color="green">Cancel</v-btn>

              <v-btn dark @click="deleteItemConfirm3(itemSelected)" color="red"
                >Confirm</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
            <br />
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete4" max-width="500px">
          <v-card class="card-shadow card-padding">
            <v-card-title>
              {{
                lang == "th"
                  ? "คุณแน่ใจว่าต้องการลบ"
                  : "Are you sure you want to delete"
              }}
              ({{ itemSelected.name }})</v-card-title
            >
            <v-card-actions class="pb-0">
              <v-spacer></v-spacer>
              <v-btn dark @click="closeDelete" color="green">Cancel</v-btn>

              <v-btn dark @click="deleteItemConfirm4(itemSelected)" color="red"
                >Confirm</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
            <br />
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GlobalFunction } from "./functions";
import moment from "moment";
import {
  getFirestore,
  collection,
  query,
  where,
  doc,
  addDoc,
  setDoc,
  getDoc,
  // getDocs,
  deleteDoc,
  Timestamp,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export default {
  mixins: [GlobalFunction],
  data: () => ({
    userData: {},
    editedItem: {},
    itemSelected: {},
    positionListSelected: [],
    dialog3: false,
    dialog4: false,
    dialogDelete3: false,
    dialogDelete4: false,
    valid: true,
    ready: false,
    editedIndex: -1,
    position: "",
    uploadprogress: 0,
    modal31: false,
    modal32: false,
    modal41: false,
    modal42: false,
    transactionData1: [],
    transactionData2: [],
    transactionData3: [],
    transactionData4: [],
    search1: "",
    search2: "",
    search3: "",
    search4: "",
    sum1: 0,
    sum2: 0,
    sum3: 0,
    sum4: 0,
    total: 0,
    maxtotal: 40,
    totalmoney: 0,
    timequery: new Date("2023-05-31"),
    lang: "",
    // th: "",
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    showFormUpload: false,
    fileUpload: null,
    headers1Selected: [],
    headers2Selected: [],
    headers3Selected: [],
    headers4Selected: [],

    headers1: [
      // { text: "วันเวลา", value: "timestamp" },
      { text: "ชื่อ โครงการ/หน่วยบริการ", value: "name" },
      { text: "ผู้ขอรับบริการ/หน่วยงาน", value: "employer" },
      { text: "ประเภทงานบริการ", value: "type" },
      { text: "วันที่เริ่มโครงการ", value: "startdate" },
      { text: "หน้าที่ในโครงการ", value: "position" },
      { text: "ค่าบริการวิชาการทั้งหมด", value: "value" },
      { text: "เงินจัดสรรให้มหาวิทยาลัย", value: "servicecharge" },
      { text: "วันที่จ่ายเงิน", value: "paiddate" },
      { text: "หมายเหตุ", value: "note" },
      // { text: "วันที่จบโครงการ", value: "enddate" },
      // { text: "คะแนนประเมิน", value: "score" },
    ],

    headers1en: [
      // { text: "วันเวลา", value: "timestamp" },
      { text: "Project Name/Service Unit", value: "name" },
      { text: "Service applicant/agency", value: "employer" },
      { text: "Type of service", value: "type" },
      { text: "Project start date", value: "startdate" },
      { text: "Project duties", value: "position" },
      { text: "All academic fees", value: "value" },
      { text: "Money allocated to the university", value: "servicecharge" },
      { text: "Payment date", value: "paiddate" },
      { text: "Note", value: "note" },
      // { text: "วันที่จบโครงการ", value: "enddate" },
      // { text: "คะแนนประเมิน", value: "score" },
    ],

    headers2: [
      { text: "ชื่อโครงการ", value: "name" },
      { text: "ผู้ขอรับบริการ", value: "requestby" },

      { text: "ตำแหน่งในโครงการ", value: "position" },
      { text: "หน้าที่", value: "note" },
      { text: "วันที่เริ่มโครงการ", value: "startdate" },
      { text: "วันที่จบโครงการ", value: "enddate" },
      { text: "ผลการดำเนินงาน", value: "result" },
    ],

    headers2en: [
      { text: "Project Name", value: "name" },
      { text: "Service applicant", value: "requestby" },

      { text: "Position in the project", value: "position" },
      { text: "Duty", value: "note" },
      { text: "Project start date", value: "startdate" },
      { text: "Project end date", value: "enddate" },
      { text: "Project results", value: "result" },
    ],

    headers3: [
      { text: "ชื่อโครงการ/กิจกรรม", value: "name" },
      { text: "หน้าที่/บทบาท", value: "position" },
      { text: "หน่วยงานที่รับบริการ", value: "recipient" },
      { text: "ภายใน/ภายนอก", value: "recipienttype" },
      { text: "ระยะเวลา", value: "result" },

      { text: "วันที่เริ่มโครงการ", value: "startdate" },
      { text: "วันที่จบโครงการ", value: "enddate" },

      { text: "คะแนนประเมิน", value: "score", align: "center" },
      { text: "ไฟล์แนบ", value: "url" },
      { text: "จัดการ", value: "actions" },
    ],

    headers3en: [
      { text: "Project Name/Activity", value: "name" },
      { text: "Position/Role", value: "position" },
      { text: "Service recipient", value: "recipient" },
      { text: "Internal/External", value: "recipienttype" },
      { text: "Duration", value: "result" },

      { text: "Project start date", value: "startdate" },
      { text: "Project end date", value: "enddate" },

      { text: "Evaluation score", value: "score", align: "center" },
      { text: "Attachment", value: "url" },
      { text: "Manage", value: "actions" },
    ],
    headers4: [
      { text: "ชื่อวารสาร/งานประชุม", value: "name" },
      { text: "ชื่อบทความ", value: "projectname" },
      { text: "หน่วยงานที่รับบริการ", value: "recipient" },
      { text: "ภายใน/ภายนอก", value: "recipienttype" },
      // { text: "ระยะเวลา", value: "result" },

      { text: "วันที่เริ่มโครงการ", value: "startdate" },
      { text: "วันที่จบโครงการ", value: "enddate" },

      { text: "คะแนนประเมิน", value: "score", align: "center" },
      { text: "ไฟล์แนบ", value: "url" },
      { text: "จัดการ", value: "actions" },
    ],
    headers4en: [
      { text: "Journal/Conference", value: "name" },
      { text: "Article name", value: "projectname" },
      { text: "Service recipient", value: "recipient" },
      { text: "Internal/External", value: "recipienttype" },
      // { text: "Duration", value: "result" },

      { text: "Project start date", value: "startdate" },
      { text: "Project end date", value: "enddate" },

      { text: "Evaluation score", value: "score", align: "center" },
      { text: "Attachment", value: "url" },
      { text: "Manage", value: "actions" },
    ],

    nameRule: [(v) => !!v || "กรุณาระบุชื่อโครงการ"],
    typenameRule: [
      (v) => !!v || "วารสาร/งานประชุมวิชาการ/การพิจารณาตำแหน่งวิชาการ",
    ],

    projectnameRule: [(v) => !!v || "กรุณาระบุชื่อบทความ/ผลงาน/โครงการ"],
    positionRule: [(v) => !!v || "กรุณาระบุหน้าที่ในโครงการ"],
    resultRule: [(v) => !!v || "กรุณาระบุผลลัพธ์ของโครงการ"],
    urlRule: [(v) => !!v || "กรุณาระบุ Link หลักฐานประกอบ"],
    recipientRule: [(v) => !!v || "กรุณาระบุหน่วยงานที่รับบริการ"],
    recipienttypeRule: [(v) => !!v || "กรุณาระบุประเภทผู้ให้บริการ"],
    year: 0,
    db: getFirestore(),
  }),

  methods: {
    validate(num) {
      if (this.$refs.form.validate()) {
        if (this.editedIndex == -1) {
          if (num == 3) {
            this.createItem3();
          } else if (num == 4) {
            this.createItem4();
          }
        } else {
          if (num == 3) {
            this.updateItem3();
          } else if (num == 4) {
            this.updateItem4();
          }
        }
        this.close();
      } else {
        console.log("Form validation fail");
      }
    },
    checkEndDate() {
      if (
        new Date(this.editedItem.enddate).getTime() >=
        new Date(this.editedItem.startdate).getTime()
      ) {
        return true;
      } else {
        return "วันที่จบโครงการต้องกำหนดตั้งแต่วันที่เริ่มโครงการเป็นต้นไป";
      }
    },
    async createItem3() {
      this.editedItem.staffid = this.userData.emp_id;
      if (this.position != "") {
        this.editedItem.position = this.position;
      }
      if (this.editedItem.result == "ระยะเวลาไม่เกิน 6 ชั่วโมง") {
        this.editedItem.score = 2;
      } else if (this.editedItem.result == "ระยะเวลาไม่เกิน 12 ชั่วโมง") {
        this.editedItem.score = 4;
      } else if (this.editedItem.result == "ระยะเวลามากกว่า 12 ชั่วโมง") {
        this.editedItem.score = 5;
      }
      this.editedItem.timestamp = Timestamp.fromDate(new Date());

      try {
        const docRef = await addDoc(
          collection(this.db, "transaction3"),
          this.editedItem
        );
        console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    },
    async createItem4() {
      console.log(this.editedItem);
      this.editedItem.staffid = this.userData.emp_id;

      // if (this.editedItem.result == "ระยะเวลาไม่เกิน 6 ชั่วโมง") {
      //   this.editedItem.score = 2;
      // } else if (this.editedItem.result == "ระยะเวลาไม่เกิน 12 ชั่วโมง") {
      //   this.editedItem.score = 4;
      // } else if (this.editedItem.result == "ระยะเวลามากกว่า 12 ชั่วโมง") {
      //   this.editedItem.score = 5;
      // }
      this.editedItem.score = 3;
      this.editedItem.timestamp = Timestamp.fromDate(new Date());

      try {
        const docRef = await addDoc(
          collection(this.db, "transaction4"),
          this.editedItem
        );
        console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    },

    async getTransaction1() {
      this.loading1 = true;

      let q = query(
        collection(this.db, "transaction1"),
        where("staffid", "==", this.userData.emp_id),
        where("timestamp", ">", this.timequery),
        orderBy("timestamp", "desc")
      );

      onSnapshot(q, (querySnapshot) => {
        this.transactionData1 = [];
        var tmp = {};
        this.sum1 = 0;
        querySnapshot.forEach((doc) => {
          this.sum1 = doc.data().servicecharge + this.sum1;
          this.getProjectDetail(doc.data().projectid)
            .then((result) => {
              if (result != false) {
                tmp = { ...result, ...doc.data() };
                this.transactionData1.push(tmp);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        });
        this.calculateMoney();
        this.totalSum();
        this.loading1 = false;
      });
    },

    calculateMoney() {
      var scoreMoney = 0;
      this.totalmoney = this.sum1;
      // console.log(parseInt(this.sum1));
      if (parseInt(this.sum1) >= 100) {
        scoreMoney = 10;
        this.sum1 = parseInt(this.sum1) - 2500;
        // console.log("part1 " + scoreMoney);
      }

      if (parseInt(this.sum1) >= 2500) {
        console.log(parseInt(this.sum1));
        var result = parseInt(this.sum1) / 2500;
        // console.log(result);
        scoreMoney = scoreMoney + result;
        // console.log("part2 " + scoreMoney);
      }
      this.sum1 = scoreMoney;
    },

    async getProjectDetail(projectid) {
      const docRef = doc(this.db, "project1", projectid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // console.log("Document data:", docSnap.data());
        const result = docSnap.data();
        return result;
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        return false;
      }
    },

    async getTransaction2() {
      this.loading2 = true;
      let idText = parseInt(this.userData.emp_id);
      // console.log(idText);
      let q = query(
        collection(this.db, "transaction2"),
        where("staffid", "==", idText),
        where("timestamp", ">", this.timequery),
        orderBy("timestamp", "desc")
      );

      onSnapshot(q, (querySnapshot) => {
        this.transactionData2 = [];
        var tmp = {};
        this.sum2 = 0;
        // console.log(querySnapshot.size);
        querySnapshot.forEach((doc) => {
          this.sum2 = 0;
          // this.sum2 = doc.data().servicecharge + this.sum2;
          this.getProjectDetail2(doc.data().projectid)
            .then((result) => {
              if (result != false) {
                // console.log(result);
                tmp = { ...result, ...doc.data() };
                this.transactionData2.push(tmp);

                this.sum2 = parseInt(tmp.result) + parseInt(this.sum2);
              }

              this.totalSum();
            })
            .catch((err) => {
              console.log(err);
            });
        });

        this.loading2 = false;
      });
    },

    async getProjectDetail2(projectid) {
      const docRef = doc(this.db, "project2", projectid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // console.log("Document data:", docSnap.data());
        const result = docSnap.data();
        return result;
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        return false;
      }
    },

    async getTransaction3() {
      this.loading3 = true;

      let q = query(
        collection(this.db, "transaction3"),
        where("staffid", "==", this.userData.emp_id),
        where("timestamp", ">", this.timequery),
        orderBy("timestamp", "desc")
      );

      onSnapshot(q, (querySnapshot) => {
        this.transactionData3 = [];
        var tmp = {};
        this.sum3 = 0;
        querySnapshot.forEach((doc) => {
          tmp = Object.assign({ id: doc.id }, doc.data());
          this.transactionData3.push(tmp);
          this.sum3 = doc.data().score + this.sum3;
        });
        this.totalSum();
        this.loading3 = false;
      });
    },

    async getTransaction4() {
      this.loading4 = true;

      let q = query(
        collection(this.db, "transaction4"),
        where("staffid", "==", this.userData.emp_id),
        where("timestamp", ">", this.timequery),
        orderBy("timestamp", "desc")
      );

      onSnapshot(q, (querySnapshot) => {
        this.transactionData4 = [];
        var tmp = {};
        this.sum4 = 0;
        querySnapshot.forEach((doc) => {
          tmp = Object.assign({ id: doc.id }, doc.data());
          this.transactionData4.push(tmp);
          this.sum4 = doc.data().score + this.sum4;
        });
        this.totalSum();
        this.loading4 = false;
      });
    },
    editItem3(item) {
      this.dialogType = "Update";

      this.editedIndex = item.id;

      // console.log(item);
      this.editedItem = Object.assign({}, item);

      this.dialog3 = true;
      // console.log(this.editedItem);
    },
    editItem4(item) {
      this.dialogType = "Update";

      this.editedIndex = item.id;

      // console.log(item);
      this.editedItem = Object.assign({}, item);

      this.dialog4 = true;
      // console.log(this.editedItem);
    },

    async updateItem3() {
      // console.log(this.editedItem);

      this.editedItem.updatedate = Timestamp.fromDate(new Date());
      await setDoc(
        doc(this.db, "transaction3", this.editedIndex),
        this.editedItem
      );
      // console.log("Update");
      // Object.assign(this.transactionData[this.editedIndex], this.editedItem);
      // localStorage.setItem("bmi", JSON.stringify(this.transactionData));
    },
    async updateItem4() {
      // console.log(this.editedItem);

      this.editedItem.updatedate = Timestamp.fromDate(new Date());
      await setDoc(
        doc(this.db, "transaction4", this.editedIndex),
        this.editedItem
      );
      // console.log("Update");
      // Object.assign(this.transactionData[this.editedIndex], this.editedItem);
      // localStorage.setItem("bmi", JSON.stringify(this.transactionData));
    },

    deleteItem3(item) {
      this.itemSelected = item;
      // this.editedIndex = this.bmiTable.indexOf(item);

      this.editedIndex = item.id;
      this.editedItem = Object.assign({}, item);
      this.dialogDelete3 = true;
    },
    deleteItem4(item) {
      this.itemSelected = item;
      // this.editedIndex = this.bmiTable.indexOf(item);

      this.editedIndex = item.id;
      this.editedItem = Object.assign({}, item);
      this.dialogDelete4 = true;
    },
    async deleteItemConfirm3() {
      // this.bmiTable.splice(this.editedIndex, 1);
      // localStorage.setItem("bmi", JSON.stringify(this.bmiTable));

      await deleteDoc(doc(this.db, "transaction3", this.editedIndex));

      this.closeDelete();
    },
    async deleteItemConfirm4() {
      // this.bmiTable.splice(this.editedIndex, 1);
      // localStorage.setItem("bmi", JSON.stringify(this.bmiTable));

      await deleteDoc(doc(this.db, "transaction4", this.editedIndex));

      this.closeDelete();
    },

    uploadFile() {
      const storage = getStorage();
      // Create the file metadata
      /** @type {any} */
      const metadata = {
        contentType: this.fileUpload.type,
      };

      // console.log(this.fileUpload);
      // Upload file and metadata to the object 'images/mountains.jpg'
      const storageRef = ref(
        storage,
        "filereference/" + this.userData.emp_id + "/" + this.fileUpload.name
      );

      const uploadTask = uploadBytesResumable(
        storageRef,
        this.fileUpload,
        metadata
      );

      // Listen for state changes, errors, and completion of the upload.
      uploadTask
        .on(
          "state_changed",
          (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            this.uploadprogress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + this.uploadprogress + "% done");
            switch (snapshot.state) {
              case "paused":
                console.log("Upload is paused");
                break;
              case "running":
                console.log("Upload is running");
                break;
            }
          },
          (error) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case "storage/unauthorized":
                // User doesn't have permission to access the object
                break;
              case "storage/canceled":
                // User canceled the upload
                break;

              // ...

              case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                break;
            }
          },
          () => {
            // Upload completed successfully, now we can get the download URL
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              this.editedItem.url = downloadURL;
              this.fileUpload = null;
              this.showFormUpload = false;
              console.log("File available at", downloadURL);
            });
          }
        )
        .bind(this);
    },
    formatTimestamp(t) {
      t = new Date(t);
      if (t instanceof Date) {
        return t.toLocaleDateString("en-GB");
      } else if (t == undefined) {
        return t;
      } else {
        // return t.toLocaleString("th-TH", { timeZone: "Asia/Bangkok" });
        return t;
      }
    },

    formatNumber(t) {
      if (t instanceof Number) {
        return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    print() {
      window.print();
    },
    close() {
      this.dialog3 = false;
      this.dialog4 = false;
    },
    closeDelete() {
      this.dialogDelete3 = false;
      this.dialogDelete4 = false;
      this.clear();
    },

    clear() {
      this.showFormUpload = false;
      this.editedItem = {};
      this.editedItem.startdate = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
    },
    totalSum() {
      this.total = this.sum1 + this.sum2 + this.sum3 + this.sum4;
    },

    async getTransactionAll(year) {
      this.transactionData1 = [];
      this.transactionData2 = [];
      this.transactionData3 = [];
      this.transactionData4 = [];

      if (year == "2022") {
        this.timequery = new Date("2022-05-31");
      } else if (year == "2023") {
        this.timequery = new Date("2023-05-31");
      } 
      else if (year == "2024") {
        this.timequery = new Date("2024-05-31");
      }
      else {
        this.timequery = new Date("2020-05-31");
      }

      await this.getTransaction1();
      await this.getTransaction2();
      await this.getTransaction3();
      await this.getTransaction4();
    },
    switchLanguage(input) {
      if (input == "th") {
        this.lang = "th";
        this.headers1Selected = this.headers1;
        this.headers2Selected = this.headers2;
        this.headers3Selected = this.headers3;
        this.headers4Selected = this.headers4;
        this.positionListSelected = [
          "วิทยากร",
          "อาจารย์พิเศษ",
          "ประธาน",
          "กรรมการ",
          "อนุกรรมการ",
          "นายก",
          "เลขานุการ",
          "ผู้ทรงคุณวุฒิ",
          "อื่น ๆ โปรดระบุ",
        ];
      }
      if (input == "en") {
        this.lang = "en";
        this.headers1Selected = this.headers1en;
        this.headers2Selected = this.headers2en;
        this.headers3Selected = this.headers3en;
        this.headers4Selected = this.headers4en;
        this.positionListSelected = [
          "Speaker",
          "Special Lecturer",
          "Chairman",
          "Committee",
          "Sub Committee",
          "President",
          "Secretary",
          "Expert",
          "Other",
        ];
      }
    },

    printDownload() {
      let w = window.open();
      w.document.write(this.$refs.DownloadComp.$el.innerHTML);
      w.document.close();
      w.setTimeout(function () {
        w.print();
      }, 1000);
    },
  },
  watch: {},
  options: {},
  created() {
    this.lang = "th";
  },
  computed: {
    formTitle() {
      if (this.lang == "th") {
        return this.editedIndex === -1 ? "เพิ่ม" : "บันทึก";
      } else if (this.lang == "en") {
        return this.editedIndex === -1 ? "Add" : "Save";
      } else {
        return this.editedIndex === -1 ? "เพิ่ม" : "บันทึก";
      }
    },
  },

  async mounted() {
    this.headers1Selected = this.headers1;
    this.headers2Selected = this.headers2;
    this.headers3Selected = this.headers3;
    this.headers4Selected = this.headers4;

    this.positionListSelected = [
      "วิทยากร",
      "อาจารย์พิเศษ",
      "ประธาน",
      "กรรมการ",
      "อนุกรรมการ",
      "นายก",
      "เลขานุการ",
      "ผู้ทรงคุณวุฒิ",
      "อื่น ๆ โปรดระบุ",
    ];

    // setTimeout(() => {
    //   if (this.transactionData3.length == 0) {
    //     this.getTransaction3();
    //   }
    // }, 2000);

    this.editedItem.startdate = new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10);

    var d = new Date();
    var year = d.getFullYear();
    if (d.getMonth() <= 4) {
      this.year = d.getFullYear() - 1;
    } else if (d.getMonth() >= 5) {
      this.year = d.getFullYear();
    }

    await this.showUser();
    await this.getTransactionAll(this.year);
    // await this.getTransaction1();
    // await this.getTransaction2();
    // await this.getTransaction3();
    // await this.getTransaction4();
  },
};
</script>

<style>
.centered-input.v-text-field .v-label {
  left: 50% !important;
  transform: translateX(-50%);
  transform-origin: top 50%;
}
.centered-input.v-text-field .v-label--active {
  left: 0% !important;
  transform: translateY(-25px) scale(0.75) translateX(0px);
}
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
  @page {
    size: landscape;
  }
  hr {
    margin-top: 50px;
    page-break-before: always;
  }
}
</style>
